import { PortableTextType } from "typings/modules"

export const getFirstLine = (content: PortableTextType) =>
  content?.[0]?.children?.[0]?.text || ""

export const getFirstLineBlurb = (content: PortableTextType) => {
  const firstLine = getFirstLine(content).slice(0, 50)
  return firstLine ? firstLine + "..." : firstLine
}
